import { useEffect } from "react";

const CANONICAL_HOST = "https://ccchaps.com";
const NODE_ID_PREFIX = "breadcrumb-schema-";

/**
 * BreadcrumbList JSON-LD (schema-only, no visual breadcrumb rendered).
 *
 * @param {Object} props
 * @param {Array<{name: string, path: string}>} props.items - Ordered crumbs, home first.
 * @param {string} [props.id] - Optional unique id suffix to allow multiple on one page.
 */
export default function BreadcrumbSchema({ items, id = "default" }) {
  useEffect(() => {
    if (!items || items.length === 0) return;
    const data = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        item: `${CANONICAL_HOST}${it.path}`,
      })),
    };
    const nodeId = `${NODE_ID_PREFIX}${id}`;
    let el = document.getElementById(nodeId);
    if (!el) {
      el = document.createElement("script");
      el.id = nodeId;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(data);

    return () => {
      const node = document.getElementById(nodeId);
      if (node) node.remove();
    };
  }, [items, id]);

  return null;
}
